import globalAgent from 'src/agent';
import qs from 'qs';
import { URLS } from 'src/constants/urls';

import type { AxiosPromise } from 'axios';
import type {
    IMessagesResponse,
    IMessagesRequest,
    IMessagesStatsResponse,
    IMessagesDailyStatsResponse,
    MessageLeadFeedback,
} from 'src/types/Message';

export const getMessages = (params: IMessagesRequest): AxiosPromise<IMessagesResponse> => {
    const _params = qs.stringify({ ...params }, { skipNulls: true, addQueryPrefix: true });
    return globalAgent.get(`${URLS.MESSAGES}${_params}`);
};

export const getMessagesStats = (
    params: Omit<IMessagesRequest, 'limit' | 'offset'>
): AxiosPromise<IMessagesStatsResponse> => {
    const _params = qs.stringify({ ...params }, { skipNulls: true, addQueryPrefix: true });
    return globalAgent.get(`${URLS.MESSAGES}stats/messages/highlights${_params}`);
};

export const getMessagesDailyStats = (params: {
    from: string;
    to: string;
    relevant_only?: boolean;
    bundles?: string;
    chat_ids?: string;
    keywords?: string;
}): AxiosPromise<IMessagesDailyStatsResponse> => {
    const _params = qs.stringify({ ...params }, { skipNulls: true, addQueryPrefix: true });
    return globalAgent.get(`${URLS.MESSAGES}stats/messages/daily${_params}`);
};

export const toggleFavorite = (id: number, flag: boolean): AxiosPromise<unknown> => {
    return globalAgent.patch(`${URLS.MESSAGES}${id}/`, { is_favorite: flag });
};

export const setMessageFeedback = (
    id: number,
    feedback: MessageLeadFeedback
): AxiosPromise<{ feedback: MessageLeadFeedback }> => {
    return globalAgent.post(`${URLS.MESSAGES}${id}/feedback/`, { feedback });
};

export const removeMessage = (id: number): AxiosPromise<unknown> => {
    return globalAgent.delete(`${URLS.MESSAGES}${id}/`);
};
